<template>
    <div class="tw-grid xs:tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6">
        <!-- Programa Livre -->
        <section :class="[
            'tw-rounded-2xl tw-p-6 tw-shadow-2xl',
            theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'
        ]">
            <div class="tw-flex tw-items-center tw-gap-3 tw-mb-6">
                <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-blue-500/10 tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-600'">
                    <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
                </div>
                <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Programa Livre</h3>
            </div>
            
            <div class="tw-space-y-4">
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Temperatura Máxima</label>
                    <input id="temperatura_maxima_livre" :disabled="!permissaoEditar" type="number" v-model="programaLivre['temperatura_maxima']" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-blue-500 tw-mt-2">
                </div>
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Temperatura Mínima</label>
                    <input id="temperatura_minima_livre" :disabled="!permissaoEditar" type="number" v-model="programaLivre['temperatura_minima']" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-blue-500 tw-mt-2">
                </div>
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Umidade Máxima</label>
                    <input id="umidade_maxima_livre" :disabled="!permissaoEditar" type="number" v-model="umidadeMaximaLivreInt" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-blue-500 tw-mt-2">
                </div>
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Umidade Mínima</label>
                    <input id="umidade_minima_livre" :disabled="!permissaoEditar" type="number" v-model="umidadeMinimaLivreInt" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-blue-500 tw-mt-2">
                </div>
            </div>
        </section>

        <!-- Programa Livre Temporizado -->
        <section :class="[
            'tw-rounded-2xl tw-p-6 tw-shadow-2xl',
            theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'
        ]">
            <div class="tw-flex tw-items-center tw-gap-3 tw-mb-6">
                <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-purple-500/10 tw-text-purple-400' : 'tw-bg-purple-50 tw-text-purple-600'">
                    <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                </div>
                <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Programa Livre Temporizado</h3>
            </div>
            
            <div class="tw-grid tw-grid-cols-2 tw-gap-4">
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Temperatura Máxima</label>
                    <input id="temperatura_maxima_livre_temporizado" :disabled="!permissaoEditar" type="number" v-model="programaLivreTemporizado['temperatura_maxima']" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-purple-500 tw-mt-2">
                </div>
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Temperatura Mínima</label>
                    <input id="temperatura_minima_livre_temporizado" :disabled="!permissaoEditar" type="number" v-model="programaLivreTemporizado['temperatura_minima']" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-purple-500 tw-mt-2">
                </div>
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Umidade Máxima</label>
                    <input id="umidade_maxima_livre_temporizado" :disabled="!permissaoEditar" type="number" v-model="umidadeMaximaTemporizadoInt" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-purple-500 tw-mt-2">
                </div>
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Umidade Mínima</label>
                    <input id="umidade_minima_livre_temporizado" :disabled="!permissaoEditar" type="number" v-model="umidadeMinimaTemporizadoInt" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-purple-500 tw-mt-2">
                </div>
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Horário Início</label>
                    <input id="horario_inicio" :disabled="!permissaoEditar" type="time" v-model="programaLivreTemporizado['horario_inicio']" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-purple-500 tw-mt-2">
                </div>
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Horário Término</label>
                    <input id="horario_final" :disabled="!permissaoEditar" type="time" v-model="programaLivreTemporizado['horario_final']" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-purple-500 tw-mt-2">
                </div>
            </div>
        </section>

        <!-- Programa Equilíbrio Higroscópico -->
        <section :class="[
            'tw-rounded-2xl tw-p-6 tw-shadow-2xl',
            theme === 'dark' ? 'tw-bg-[#1a1d21]' : 'tw-bg-white'
        ]">
            <div class="tw-flex tw-items-center tw-gap-3 tw-mb-6">
                <div class="tw-p-2.5 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-amber-500/10 tw-text-amber-400' : 'tw-bg-amber-50 tw-text-amber-600'">
                    <svg class="tw-w-6 tw-h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3v.01M9 17h.01M15 16h.01M9 13h.01M15 12h.01M12 14h.01M12 8h.01"/></svg>
                </div>
                <h3 :class="theme === 'dark' ? 'tw-text-slate-100' : 'tw-text-slate-800'" class="tw-font-bold">Equilíbrio Higroscópico</h3>
            </div>
            
            <div class="tw-space-y-4">
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Umidade Máxima</label>
                    <input id="umidade_maxima_equilibrio" :disabled="!permissaoEditar" type="number" v-model="umidadeMaximaEquilibrioInt" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-amber-500 tw-mt-2">
                </div>
                <div>
                    <label :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-500'" class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wider">Umidade Mínima</label>
                    <input id="umidade_minima_equilibrio" :disabled="!permissaoEditar" type="number" v-model="umidadeMinimaEquilibrioInt" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white' : 'tw-bg-gray-100 tw-text-black'" class="tw-w-full tw-rounded-xl tw-p-3 tw-text-sm focus:tw-ring-2 focus:tw-ring-amber-500 tw-mt-2">
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    props: {
        parametros: {
            type: Object,
            default: () => ({})
        },
        permissaoEditar: {
            type: Boolean,
            required: true
        },
        theme: {
            type: String,
            default: 'light'
        }
    },
    computed: {
        programaLivre() {
            if (this.parametros && this.parametros['1']) {
                return this.parametros['1']
            }
            return {
                "temperatura_maxima": "",
                "temperatura_minima": "",
                "umidade_maxima": "",
                "umidade_minima": ""
            }
        },
        programaLivreTemporizado() {
            if (this.parametros && this.parametros['2']) {
                return this.parametros['2']
            }
            return {
                "temperatura_maxima": "",
                "temperatura_minima": "",
                "umidade_maxima": "",
                "umidade_minima": "",
                "horario_inicio": "",
                "horario_final": ""
            }        
        },
        programaEquilibrioHigroscopico() {
            if (this.parametros && this.parametros['3']) {
                return this.parametros['3']
            }
            return {
                "umidade_maxima": "",
                "umidade_minima": ""
            }        
        },
        umidadeMaximaLivreInt() {
            return parseInt(this.programaLivre['umidade_maxima'])
        },
        umidadeMinimaLivreInt() {
            return parseInt(this.programaLivre['umidade_minima'])
        },
        umidadeMaximaTemporizadoInt() {
            return parseInt(this.programaLivreTemporizado['umidade_maxima'])
        },
        umidadeMinimaTemporizadoInt() {
            return parseInt(this.programaLivreTemporizado['umidade_minima'])
        },
        umidadeMaximaEquilibrioInt() {
            return parseInt(this.programaEquilibrioHigroscopico['umidade_maxima'])
        },
        umidadeMinimaEquilibrioInt() {
            return parseInt(this.programaEquilibrioHigroscopico['umidade_minima'])
        },
    },
    methods: {
        getParametrosProgramas() {
            return [
                {
                    "programa_id": 1,
                    "temperatura_maxima": parseInt(document.getElementById('temperatura_maxima_livre').value) || parseInt(this.programaLivre['temperatura_maxima']),
                    "temperatura_minima": parseInt(document.getElementById('temperatura_minima_livre').value) || parseInt(this.programaLivre['temperatura_minima']),
                    "umidade_maxima": parseInt(document.getElementById('umidade_maxima_livre').value) || parseInt(this.programaLivre['umidade_maxima']),
                    "umidade_minima": parseInt(document.getElementById('umidade_minima_livre').value) || parseInt(this.programaLivre['umidade_minima'])
                },
                {
                    "programa_id": 2,
                    "temperatura_maxima": parseInt(document.getElementById('temperatura_maxima_livre_temporizado').value) || parseInt(this.programaLivreTemporizado['temperatura_maxima']),
                    "temperatura_minima": parseInt(document.getElementById('temperatura_minima_livre_temporizado').value) || parseInt(this.programaLivreTemporizado['temperatura_minima']),
                    "umidade_maxima": parseInt(document.getElementById('umidade_maxima_livre_temporizado').value) || parseInt(this.programaLivreTemporizado['umidade_maxima']),
                    "umidade_minima": parseInt(document.getElementById('umidade_minima_livre_temporizado').value) || parseInt(this.programaLivreTemporizado['umidade_minima']),
                    "horario_inicio": this.programaLivreTemporizado['horario_inicio'].substring(0, 5),
                    "horario_final": this.programaLivreTemporizado['horario_final'].substring(0, 5)
                },
                {
                    "programa_id": 3,
                    "umidade_maxima": parseInt(document.getElementById('umidade_maxima_equilibrio').value) || parseInt(this.programaEquilibrioHigroscopico['umidade_maxima']),
                    "umidade_minima": parseInt(document.getElementById('umidade_minima_equilibrio').value) || parseInt(this.programaEquilibrioHigroscopico['umidade_minima'])
                }
            ]
        }
    }
}
</script>